import { AccountLookup } from 'containers/AccountLookUp'

export default AccountLookup
